/**
 * A game mode owns everything about *why* you are shooting: who spawns where,
 * when a round starts and ends, and what the HUD says about it.
 *
 * `Game` keeps owning the simulation — movement, weapons, physics, effects —
 * and calls into the mode at four points only (construct, tick, enemy death,
 * HUD state). That boundary is deliberate: deathmatch is the code path every
 * regression probe drives, so bomb mode must not be able to change it.
 */
export class GameMode {
  static id = 'dm';

  constructor(game, opts = {}) {
    this.game = game;
    this.opts = opts;
  }

  /** Called once, after Game's constructor has built everything. */
  start() {}

  /** Called from Game.update after the world has ticked. */
  update(dt) {}

  /** True while the mode owns input — freeze time, round end, spectating. */
  get inputLocked() { return false; }

  /** Mutate the HUD state object Game built. */
  decorateHud(s) {}

  /** A bot died. `byPlayer` is true when the player got the kill. */
  onEnemyDeath(enemy, byPlayer) {}

  /** The player died. Return true to suppress the default respawn. */
  onPlayerDeath(dir) { return false; }
}
